import { useEffect, useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import api from "@/lib/api";
import { WARDROBE } from "@/constants/assets";
import { Check, Shirt } from "lucide-react";

export default function WardrobeShelf({ open, onClose, character, onApply }) {
  const [adminOutfits, setAdminOutfits] = useState([]);

  useEffect(() => {
    if (!open || !character) return;
    api.get("/assets", { params: { category: "outfit", origin: character.origin } })
      .then(({ data }) => setAdminOutfits(data.map((a) => ({
        label: a.outfit_label, url: `data:image/jpeg;base64,${a.image_base64}` }))))
      .catch(() => setAdminOutfits([]));
  }, [open, character]);

  const outfits = [{ label: "Original Look", url: character?.avatar_url }, ...WARDROBE, ...adminOutfits];

  return (
    <Sheet open={open} onOpenChange={(v) => !v && onClose()}>
      <SheetContent side="right" className="bg-surface border-white/10 w-full sm:max-w-md p-0" data-testid="wardrobe-shelf">
        <SheetHeader className="p-6 border-b border-white/10">
          <SheetTitle className="font-heading text-xl flex items-center gap-2">
            <Shirt className="w-5 h-5 text-brand" /> Wardrobe
          </SheetTitle>
        </SheetHeader>
        <div className="p-6 grid grid-cols-2 gap-4 overflow-y-auto h-[calc(100vh-90px)]">
          {outfits.map((o, i) => {
            const active = character?.active_outfit_url === o.url;
            return (
              <button key={i} data-testid={`wardrobe-item-${i}`} onClick={() => onApply(o.url)}
                className={`relative rounded-2xl overflow-hidden border-2 transition-colors aspect-[3/4] ${active ? "border-brand" : "border-transparent hover:border-white/20"}`}>
                <img src={o.url} alt={o.label} className="w-full h-full object-cover" />
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent p-2.5">
                  <span className="text-xs font-medium">{o.label}</span>
                </div>
                {active && (
                  <div className="absolute top-2 right-2 w-6 h-6 rounded-full bg-brand flex items-center justify-center">
                    <Check className="w-3.5 h-3.5 text-white" />
                  </div>
                )}
              </button>
            );
          })}
        </div>
      </SheetContent>
    </Sheet>
  );
}
